





















































































/** @format */

import { Component, Prop, Vue } from 'vue-property-decorator';
import Logo from '@/components/logo/index.vue';
import { isShiDaill } from '@/utils/env';

/**
 * 身份验证相关页面入口
 */
@Component({
  components: { Logo }
})
export default class Auth extends Vue {
  isShiDaill = isShiDaill;
  /**
   * LOGO图片
   */
  // @ts-ignore
  logoPic: string = window.VUE_APP_SERVER_CONFIG.META.logoUrl;

  // 轮播相关
  textCarouselRef: string = 'auth-text-carousel';
  bgCarouselRef: string = 'auth-bg-carousel';

  carouselPrevIndex: number = 0;

  carouselList: Array<object> = [
    {
      first_line: '车场联网',
      second_line: '数据实时上云',
      first_sub_line: '车辆出/入场数据、缴费数据、异常数据等实时上云',
      second_sub_line: '数据透明，实现颗粒归仓',
      bgUrl:
        'https://gw.alipayobjects.com/os/q/cms/images/kiiiib0j/57df84ce-5375-4f38-bfbd-94f8abdf7a8b_w1920_h1000.jpg'
    },
    {
      first_line: '支付电子化',
      second_line: '业务线上化',
      first_sub_line: '多元化电子支付、无感支付，实现车辆快速通行',
      second_sub_line: '财务统一归集，业务统一管控',
      bgUrl:
        'https://gw.alipayobjects.com/os/q/cms/images/kiiii2xr/b898ccb6-07b8-4664-b11a-c1c63042a816_w1920_h1000.jpg'
    },
    {
      first_line: '远程集管',
      second_line: '收费无人化',
      first_sub_line: '云坐席24小时远程集中管理，实现车场管理',
      second_sub_line: '无人化、少人化，减员增效',
      bgUrl:
        'https://gw.alipayobjects.com/os/q/cms/images/kiiihthl/b7e44ad0-9fd0-4b21-ad19-98db6554ec4b_w1920_h1000.jpg'
    },
    {
      first_line: '大数据分析',
      second_line: 'AI智能监控',
      first_sub_line: '数据沉淀，永久保存，大数据深度价值挖掘',
      second_sub_line: '人工智能AI算法全方位实时监控',
      bgUrl:
        'https://gw.alipayobjects.com/os/q/cms/images/kiiiim4p/092f9ca5-e915-46db-a9a3-a68113d91893_w1920_h1000.jpg'
    }
  ];

  customServicePhoneNumber: string = '400-680-1600';

  /**
   * 登录标题文案
   */
  loginText: string = window.VUE_APP_SERVER_CONFIG.META.loginText;
  // 注册信息
  copyYear: any = new Date().getFullYear();
  copyTitle: string = window.VUE_APP_SERVER_CONFIG.META.title;

  /**
   * 是否正在加载企业信息
   */
  loadingCorpInfo: boolean = true;

  /**
   * 页面准备标志
   */
  readyFlag: boolean = false;

  async mounted() {
    // 获取企业信息
    // let { alias } = this.$route.params
    // if (alias) {
    //   try {
    //     const {
    //       data: { login_logo_url: loginLogo, login_logo_context: loginText },
    //     } = await api.corp.getOEM(alias)
    //     this.logoPic = loginLogo
    //     this.loginText = loginText
    //   } catch (err) {
    //     console.log(err)
    //   }
    // }
    if (this.$route.query.reload === '1') {
      //单点登录
      if (window.location.search) {
        this.readyFlag = true;
        this.loadingCorpInfo = false;
      } else {
        const queryMap = _.omit(this.$route.query, ['reload']);
        let queryString = '';
        Object.keys(queryMap).forEach(item => {
          queryString += `${item}=${queryMap[item]}&`;
        });
        window.location.replace(`/#${this.$route.path}` + (queryString ? `?${queryString.slice(0, -1)}` : ''));
        window.location.reload();
      }
    } else {
      this.readyFlag = true;
      this.loadingCorpInfo = false;
    }
    // document.querySelector()
  }

  onEnterMerchants() {
    const merchantsUrl = `/h5/business-coupon/login`;
    window.open(merchantsUrl, '_blank');
  }

  beforeTextCarouselChange(from, to) {
    // console.log('beforeTextCarouselChange', from, to);
    const bgCarousel = this.$refs[this.bgCarouselRef];
  }

  afterTextCarouselChange(current) {
    // 切换完成后，把前索引改为当前索引
    this.carouselPrevIndex = current;
  }

  beforeBgCarouselChange(from, to) {
    // const bgCarousel = this.$refs[this.bgCarouselRef];
    // if (this.carouselPrevIndex === this.carouselList.length - 1) {
    //   // @ts-ignore
    //   bgCarousel.next();
    // } else if (this.carouselPrevIndex > to) {
    //   // @ts-ignore
    //   bgCarousel.goTo(to);
    // } else {
    //   // @ts-ignore
    //   bgCarousel.goTo(to);
    // }
    const textCarousel = this.$refs[this.textCarouselRef];
    setTimeout(() => {
      if (this.carouselPrevIndex === this.carouselList.length - 1) {
        // @ts-ignore
        textCarousel.next();
      } else if (this.carouselPrevIndex > to) {
        // @ts-ignore
        textCarousel.goTo(to);
      } else {
        // @ts-ignore
        textCarousel.goTo(to);
      }
    }, 200);
  }

  afterBgCarouselChange(current) {
    //   const textCarousel = this.$refs[this.textCarouselRef];
    //   if (this.carouselPrevIndex === this.carouselList.length - 1) {
    //     // @ts-ignore
    //     textCarousel.next();
    //   } else if (this.carouselPrevIndex > current) {
    //     // @ts-ignore
    //     textCarousel.goTo(current);
    //   } else {
    //     // @ts-ignore
    //     textCarousel.goTo(current);
    //   }
  }
}
